var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react';
import { Translate } from "../../../I18N";
import { InputField, RadioSelect } from "../Forms";
import { Pill } from "./Pill";







const SelectedCounter = ({ selectedItems }) => /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Selected"), " ", selectedItems.length ? `(${selectedItems.length})` : ''
);


const SearchMultiselect = ({ items, onChange, className }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [showAll, setShowAll] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => {
    onChange(selectedItems);
  }, [onChange, selectedItems]);

  const handleSelect = (value) => {
    if (selectedItems.includes(value)) {
      setSelectedItems(selectedItems.filter((item) => item !== value));
    } else {
      setSelectedItems([...selectedItems, value]);
    }
  };

  const applyFilter = ({ target }) => {
    setShowAll(target.value === 'true');
  };

  return /*#__PURE__*/(
    _jsx("div", { className: `flex flex-col relative ${className}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sticky top-0 w-full px-2 mb-4" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      id: "search-multiselect",
      label: "search-multiselect",
      hideLabel: true,
      onChange: (e) => setSearchTerm(e.target.value),
      placeholder: "Search",
      value: searchTerm,
      clearFieldAction: () => setSearchTerm('') }
    ), /*#__PURE__*/
    _jsx(RadioSelect, {
      name: "filter",
      orientation: "horizontal",
      options: [
      {
        label: /*#__PURE__*/_jsx(Translate, {}, void 0, "All"),
        value: 'true',
        defaultChecked: true
      },
      {
        label: /*#__PURE__*/_jsx(SelectedCounter, { selectedItems: selectedItems }),
        value: 'false',
        disabled: selectedItems.length === 0
      }],

      onChange: applyFilter,
      className: "px-1 pt-4" }
    )
    ), /*#__PURE__*/

    _jsx("ul", { className: "px-2 w-full overflow-y-scroll max-h-[calc(100vh_-_9rem)]" }, void 0,
    items.map(({ label, value }) => {
      const selected = selectedItems.includes(value);
      const hidden =
      !label.toLowerCase().includes(searchTerm.toLowerCase()) || !showAll && !selected;
      const borderSyles = selected ?
      'border-sucess-200' :
      'border-transparent hover:border-primary-300';

      return /*#__PURE__*/(
        _jsx("li", { className: `mb-4 ${hidden ? 'hidden' : ''}` }, value, /*#__PURE__*/
        _jsx("button", {
          type: "button",
          className: `w-full flex text-left p-2.5 border ${borderSyles} rounded-lg items-center`,
          onClick: () => handleSelect(value) }, void 0, /*#__PURE__*/

        _jsx("span", { className: "flex-1" }, void 0, label), /*#__PURE__*/
        _jsx("div", { className: "flex-1" }, void 0, /*#__PURE__*/
        _jsx(Pill, { className: "float-right", color: selected ? 'green' : 'primary' }, void 0,
        selected ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Selected") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Select")
        )
        )
        )
        ));

    })
    )
    ));

};

export { SearchMultiselect };